import { originalPositionFor, TraceMap } from '@jridgewell/trace-mapping';

import { compileAiComponent } from './compiler/compileAiComponent';
import { registerPageCompiler } from './compiler/pageCompiler';
import { registerSourceMapReader } from './compiler/pageSourceDiagnostics';

/**
 * The runtime of page source: the factory compiler and the source map reader.
 * Every surface that renders page source imports it: `pages::ShowPage`, and
 * through `rowRuntime.ts` the component editor and the playground.
 * `pages::ShowModulePage` does not, because a built page arrives as modules.
 */
registerPageCompiler(compileAiComponent);
registerSourceMapReader({ TraceMap, originalPositionFor });
